<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="600"
    >
      <h3 slot="header" class="modal-header">专票资质详情</h3>

      <Form :label-width="120" ref="formData" :model="formData" :inline="true" v-if="formData">
        <FormItem label="项目名称" prop="projectId">
          <Select class="formwidth" v-model="formData.projectId" disabled>
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList"
                    :value="item.value" :key="'keyA'+index">{{item.text}}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="公司名称" prop="companyName">
          <Input class="formwidth" v-model="formData.companyName" disabled/>
        </FormItem>
        <FormItem label="纳税人识别号" prop="taxIdfa">
          <Input class="formwidth" v-model="formData.taxIdfa" disabled/>
        </FormItem>
        <FormItem label="开户行" prop="bank">
          <Input class="formwidth" v-model="formData.bank" disabled/>
        </FormItem>
        <FormItem label="开户行号" prop="bankNum">
          <Input class="formwidth" v-model="formData.bankNum" disabled/>
        </FormItem>
        <FormItem label="电话" prop="phone">
          <Input class="formwidth" v-model="formData.phone" disabled/>
        </FormItem>
        <FormItem label="地址" prop="address">
          <Input class="formwidth" v-model="formData.address" disabled/>
        </FormItem>
        <FormItem label="公司注册地" prop="address">
          <Input class="formwidth" v-model="formData.placeComapyName" disabled/>
        </FormItem>
        <div v-if="formData.applyState === '03'">
          <FormItem label="驳回类型"  >
            <Input class="formwidth" v-model="formData.rejectType" disabled/>
          </FormItem>
          <FormItem label="驳回原因" >
            <Input class="formwidth" type="textarea" v-model="formData.rejectReason" disabled/>
          </FormItem>
        </div>
        <div class=" ivu-form-item " style="margin-left: 7%">
          <span style="width:82px;" class="inline-b ivu-form-item-label">资质证明</span>
          <div style="display:flex;">
            <div class="upload-wrap">
              <img class="imgwidth" v-if="formData.companyCertificateUrl"  :src="formData.companyCertificateUrl" @click="showImg(formData.companyCertificateUrl)"/>
              <Upload v-if="!true"
                :action="baseUrl+'/file/uploadFile'"
                :on-success="handleSuccess0"
                :headers="{'Access-Token':token}"
                :show-upload-list="false"
                :format="['jpg','jpeg','png']"
                :on-format-error="handleError"
              >
                <div v-if="!formData.companyCertificateUrl" class="upload" :class="{error: !validateLicense1}">
                  <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
                  <p>点击上传图片</p>
                </div>
                <a v-if="formData.companyCertificateUrl" href="javascript:;">修改</a>
              </Upload>
            </div>
          </div>
        </div>
      </Form>
      <img-show :n="imgN" :src="imgSrc"></img-show>
    </Modal>
  </div>
</template>
<script>
  import {getInvoiceCompetency} from "../../../../api/invoice";
  import ImgShow from 'components/ImgShow/index'
  export default {
    // name: "Add"   ,
    components: {
      ImgShow

    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      projectList: {
        type: Array,
        default: () => {
          return []
        }
      },
      fid: {
        type: String,
        default: ''
      }
    },
    watch: {
      n() {
        this.formData=null
        this.getInvoiceCompetency()
        this.isShow = true
      }
    },
    data() {
      return {
        imgSrc: '',
        imgN: 0,
        token: '',
        baseUrl: '',
        loading: false,
        isShow: false,
        formData: null,
      }
    },
    methods: {
      showImg(src) {
        this.imgSrc = src
        this.imgN++
      },
      getInvoiceCompetency() {
        let params = {
          fid: this.fid
        }
        getInvoiceCompetency(params).then(res => {
          this.formData = res.data
        }).catch(error => {
        })

      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
      },
      cancel() {
      }
    }
  }
</script>

<style scoped>
  .formwidth {
    width: 320px;
  }
  .imgwidth {
    width: 167px;
    height: 118px;
  }
  .upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;

  }
  .upload-wrap {
    display: inline-block;
    line-height: 1;
    padding: 10px 4px;
  }

</style>
